// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/check-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-container {
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 20px;
  max-width: 95%;
  margin: 40px auto;
  padding-bottom: 40px;
  background-color: #F5F7F8;
}
.plan-container.select-plan {
  background-color: #F5F7F8;
}
.plan-container .plan-option {
  padding: 20px;
  background-color: #fff;
  min-height: 340px;
}
.plan-container .plan-option h2 {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -1px;
  border-bottom: solid 1px #E7ECEE;
  padding-bottom: 10px;
  margin-bottom: 20px;
}
.plan-container .plan-option h2 .plan-fullprice {
  height: 20px;
  font-size: 16px;
  color: #6c7275;
  font-weight: 500;
  letter-spacing: -0.02em;
  font-family: Inter;
}
.plan-container .plan-option .plan-description {
  font-weight: 500;
  font-size: 13px;
}
.plan-container .plan-option.best-option {
  color: #fff;
  background-color: #000;
  border-radius: 20px;
}
.plan-container .plan-option.best-option h4 {
  color: #3FDD78 !important;
}
.plan-container .plan-option.best-option .plan-description {
  color: #FEFEFE !important;
}
.plan-container .plan-option .plan-periodicity {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: rgba(108, 114, 117, 0.5);
}
.plan-container .plan-option .popular-opt {
  gap: 8px;
  background: #ff97e8;
  border-radius: 4px;
  color: #141718;
}
.plan-container .plan-opt {
  list-style-type: none;
  min-height: 108px;
}

.logo-subscription {
  margin-top: 40px;
  margin-bottom: 40px;
}

.header-subscription {
  text-align: center;
  margin-bottom: 40px;
}

.header-subscription h1 {
  color: #141718;
  font-size: 46px;
  font-weight: 600;
  letter-spacing: -1px;
}

.header-subscription p {
  font-size: 18px;
  color: #6C7275;
}

.plans-row > .col:nth-child(1) .plan-option.plan-option .plan-description {
  color: #000;
}

.plans-row > .col:nth-child(2) .plan-option {
  border-radius: 20px;
  margin-left: -20px;
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.plans-row > .col:nth-child(2) .plan-option.plan-option .plan-description {
  color: #000;
}

.plans-row > .col:nth-child(3) .plan-option {
  background-color: #242627;
  margin-top: -30px;
  min-height: 400px;
  border-radius: 20px;
}
.plans-row > .col:nth-child(3) .plan-option.plan-option .plan-description {
  color: #fff;
}

.plans-row > .col .plan-option h4 {
  font-weight: 700;
}

.plans-row > .col:nth-child(1) .plan-option h4 {
  color: #141718;
}

.plans-row > .col:nth-child(2) .plan-option h4 {
  color: #3E90F0;
}

.plans-row > .col:nth-child(3) .plan-option h4 {
  color: #3EDD78;
}

.plans-row > .col:nth-child(3) .plan-option h2 {
  border-bottom: solid 1px #343839;
}

.plans-row > .col:nth-child(3) .plan-option {
  color: #fff;
}

.plan-option .plan-opt li {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.plan-option .plan-opt span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center left;
  display: block;
  width: 24px;
  height: 24px;
  padding: 10px;
}

.plans-row > .col:nth-child(3) .plan-opt span {
  filter: brightness(1.5);
}

.plan-option .plan-opt div {
  line-height: 20px;
  margin-right: 0px;
  padding-left: 0px;
  font-size: 13px;
  font-weight: 500;
}

.plan-option .select-plan-btn {
  border-radius: 12px;
  width: 90%;
  align-self: center;
  font-weight: 600;
  font-size: 14px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin: 0 auto;
  background-color: #FFF;
  border: solid 2px #E7ECEE;
  color: #141718;
}

.plans-row > .col:nth-child(3) .plan-option .select-plan-btn {
  background-color: #0084FF;
  border: solid 2px #0084FF;
  color: #fff;
}

.choose-plan {
  text-align: left;
}

.choose-plan h4 {
  font-size: 24px;
  font-weight: 700;
  margin-top: 20px;
}

.choose-plan ul {
  padding-left: 0px;
}

.choose-plan ul li {
  margin-bottom: 10px;
}

.choose-plan ul li label {
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Components/PlanOption/planoption.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;AAAN;AAEM;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAAR;AAII;EACE,gBAAA;EACA,eAAA;AAFN;AAKI;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;AAHN;AAKM;EACE,yBAAA;AAHR;AAOM;EACE,yBAAA;AALR;AASI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,+BAAA;AAPN;AAUI;EACE,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AARN;AAYE;EACE,qBAAA;EACA,iBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,eAAA;EACA,cAAA;AAXF;;AAiBE;EACE,WAAA;AAdJ;;AAmBA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAhBF;AAkBE;EACE,WAAA;AAhBJ;;AAoBA;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,WAAA;AAjBJ;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,gCAAA;AAlBF;;AAqBA;EACE,WAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,yEAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;AAlBF","sourcesContent":[".plan-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 20px;\n  max-width: 95%;\n  margin: 40px auto;\n  padding-bottom: 40px;\n  background-color: #F5F7F8;\n\n  &.select-plan {\n    background-color: #F5F7F8;\n  }\n\n  .plan-option {\n    padding: 20px;\n    background-color: #fff;\n    min-height: 340px;\n\n    & h2 {\n      font-size: 26px;\n      font-weight: 700;\n      letter-spacing: -1px;\n      border-bottom: solid 1px #E7ECEE;\n      padding-bottom: 10px;\n      margin-bottom: 20px;\n\n      .plan-fullprice {\n        height: 20px;\n        font-size: 16px;\n        color: #6c7275;\n        font-weight: 500;\n        letter-spacing: -0.02em;\n        font-family: Inter;\n      }\n    }\n\n    & .plan-description {\n      font-weight: 500;\n      font-size: 13px;\n    }\n\n    &.best-option {\n      color: #fff;\n      background-color: #000;\n      border-radius: 20px;\n\n      h4 {\n        color: #3FDD78 !important;\n\n      }\n\n      .plan-description {\n        color: #FEFEFE !important;\n      }\n    }\n\n    .plan-periodicity {\n      font-style: normal;\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 40px;\n      letter-spacing: -0.01em;\n      color: rgba(108, 114, 117, 0.5);\n    }\n\n    .popular-opt {\n      gap: 8px;\n      background: #ff97e8;\n      border-radius: 4px;\n      color: #141718;\n    }\n  }\n\n  .plan-opt {\n    list-style-type: none;\n    min-height: 108px;\n  }\n}\n\n.logo-subscription {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n.header-subscription {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.header-subscription h1 {\n  color: #141718;\n  font-size: 46px;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n\n.header-subscription p {\n  font-size: 18px;\n  color: #6C7275;\n}\n\n\n\n.plans-row>.col:nth-child(1) .plan-option {\n  &.plan-option .plan-description {\n    color: #000\n  }\n\n}\n\n.plans-row>.col:nth-child(2) .plan-option {\n  border-radius: 20px;\n  margin-left: -20px;\n  margin-top: -10px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n\n  &.plan-option .plan-description {\n    color: #000\n  }\n}\n\n.plans-row>.col:nth-child(3) .plan-option {\n  background-color: #242627;\n  margin-top: -30px;\n  min-height: 400px;\n  border-radius: 20px;\n\n  &.plan-option .plan-description {\n    color: #fff\n  }\n}\n\n.plans-row>.col .plan-option h4 {\n  font-weight: 700;\n}\n\n.plans-row>.col:nth-child(1) .plan-option h4 {\n  color: #141718;\n}\n\n.plans-row>.col:nth-child(2) .plan-option h4 {\n  color: #3E90F0;\n}\n\n.plans-row>.col:nth-child(3) .plan-option h4 {\n  color: #3EDD78\n}\n\n.plans-row>.col:nth-child(3) .plan-option h2 {\n  border-bottom: solid 1px #343839;\n}\n\n.plans-row>.col:nth-child(3) .plan-option {\n  color: #fff\n}\n\n.plan-option .plan-opt li {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.plan-option .plan-opt span {\n  background: url(\"../../Assets/Images/check-circle.svg\") no-repeat center left;\n  display: block;\n  width: 24px;\n  height: 24px;\n  padding: 10px;\n}\n\n.plans-row>.col:nth-child(3) .plan-opt span {\n  filter: brightness(1.5);\n}\n\n.plan-option .plan-opt div {\n  line-height: 20px;\n  margin-right: 0px;\n  padding-left: 0px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.plan-option .select-plan-btn {\n  border-radius: 12px;\n  width: 90%;\n  align-self: center;\n  font-weight: 600;\n  font-size: 14px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  margin: 0 auto;\n  background-color: #FFF;\n  border: solid 2px #E7ECEE;\n  color: #141718;\n}\n\n.plans-row>.col:nth-child(3) .plan-option .select-plan-btn {\n  background-color: #0084FF;\n  border: solid 2px #0084FF;\n  color: #fff;\n}\n\n.choose-plan {\n  text-align: left;\n}\n\n.choose-plan h4 {\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 20px;\n}\n\n.choose-plan ul {\n  padding-left: 0px;\n}\n\n.choose-plan ul li {\n  margin-bottom: 10px;\n}\n\n.choose-plan ul li label {\n  font-size: 14px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
